import { atom } from 'recoil';

export const onsaProgressAtom = atom<number>({
    key: 'onsaProgressState',
    default: 1
});
